import React, { useEffect, useState } from 'react';
import BuzzTable from '../../../components/BuzzTable/BuzzTable';
import { toast } from 'react-toastify';
import {
  Box,
  Button,
  Chip,
  IconButton,
  makeStyles,
  Modal,
} from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import {
  addHashtagAsync,
  getAllHashtagsAsync,
  updateHashtagAsync,
} from './HashtagstStore/hashtagsSlice';

import EditIcon from '@material-ui/icons/Edit';
import TrendingUpIcon from '@material-ui/icons/TrendingUp';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import moment from 'moment';
import CustomForm from '../../../components/FormRenderer/CustomForm';
import { initializeFormData } from '../../../components/FormRenderer/utils';
import useLoader from '../../../hooks/useLoader';

const useStyle = makeStyles((theme) => ({
  chip: {
    border: '1px solid gray',
  },
  active: {
    color: theme.palette.buzzSuccess,
  },
  inactive: {
    color: theme.palette.buzzRedColor,
  },
  trending: {
    color: theme.palette.buzzRedColor,
  },
}));

const HashtagsDash = () => {
  const classes = useStyle();
  const dispatch = useDispatch();
  const { handleLoader } = useLoader();

  const [showFormModal, setFormModal] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [formTemplate, setFormTemplate] = useState(null);
  const [formData, setFormData] = useState({});

  const { hashtags } = useSelector((state) => {
    const { hashtagsReducer } = state;

    return {
      hashtags: hashtagsReducer.hashtags,
    };
  });

  useEffect(() => {
    dispatch(getAllHashtagsAsync());
  }, []);

  useEffect(() => {
    if (selectedRowId) {
      let newFormData = JSON.parse(
        JSON.stringify(hashtags.filter((item) => item._id === selectedRowId)[0])
      );

      setFormData(newFormData);
    } else setFormData(initializeFormData(formTemplate));
  }, [selectedRowId]);

  useEffect(() => {
    const formTemplate = [
      {
        id: 'form.text',
        title: 'Hashtag',
        slug: 'text',
        type: 'String',
        required: true,
      },
      {
        id: 'form.isActive',
        title: 'Status',
        slug: 'isActive',
        type: 'Select',
        options: [
          { label: 'Active', value: true },
          { label: 'InActive', value: false },
        ],
      },
    ];
    setFormTemplate(formTemplate);
    setFormData(initializeFormData(formTemplate));
  }, []);

  const hashtagsColumn = [
    {
      Header: 'Hashtag',
      accessor: 'text',
    },
    {
      Header: 'Status',
      accessor: '',
      Cell: (val) => {
        const { isActive, isTrending } = val.cell.row.original;

        return (
          <Box display="flex" sx={{ gap: '0.5rem' }}>
            {isActive ? (
              <Chip
                label="Active"
                className={classes.chip}
                variant="outlined"
                icon={<CheckCircleIcon className={classes.active} />}
              />
            ) : (
              <Chip
                label="InActive"
                className={classes.chip}
                variant="outlined"
                icon={<HighlightOffIcon className={classes.inactive} />}
              />
            )}

            {isTrending && (
              <Chip
                label="Trending"
                className={classes.chip}
                variant="outlined"
                icon={<TrendingUpIcon className={classes.trending} />}
              />
            )}
          </Box>
        );
      },
    },
    {
      Header: 'Created At',
      accessor: 'createdAt',
      Cell: (val) => {
        const { createdAt } = val.cell.row.original;
        return moment(createdAt).format('DD MMM YYYY');
      },
    },
    {
      Header: 'Action',
      Cell: (val) => {
        const { _id } = val.cell.row.original;

        return (
          <>
            <IconButton onClick={() => handleEdit(_id)}>
              <EditIcon color="secondary" />
            </IconButton>
          </>
        );
      },
    },
  ];

  const openFormModal = () => setFormModal(true);
  const closeFormModal = () => setFormModal(false);

  const handleEdit = (id) => {
    setSelectedRowId(id);
    openFormModal();
  };

  const handleCreateNew = () => {
    setSelectedRowId(null);
    openFormModal();
  };

  const handleSave = async () => {
    handleLoader(true);

    let payload = {};
    if (selectedRowId === null)
      payload = {
        ...formData,
        hashtags: [formData.text],
        isActive: formData.isActive,
      };
    else payload = formData;

    dispatch(
      selectedRowId === null
        ? addHashtagAsync(payload)
        : updateHashtagAsync({ id: selectedRowId, data: payload })
    )
      .unwrap()
      .then((res) => {
        toast.success(res.message);
        dispatch(getAllHashtagsAsync());
        closeFormModal();
      })
      .catch((error) => {
        toast.error(error.message);
      })
      .finally(() => {
        handleLoader(false);
      });
  };

  return (
    <Box>
      <Button onClick={handleCreateNew} variant={'contained'} color="primary">
        Add Hashtag
      </Button>
      <Box my={2}>
        <BuzzTable
          columns={hashtagsColumn}
          data={hashtags}
          isHandlePagination={true}
        />
      </Box>
      <Modal open={showFormModal} onClose={closeFormModal}>
        <CustomForm
          formFor={'Hashtags'}
          formTemplate={formTemplate}
          formData={formData}
          setFormData={(slug, newValue) => {
            setFormData((state) => {
              state[slug] = newValue;
              return state;
            });
            setFormTemplate((state) => {
              return JSON.parse(JSON.stringify(state));
            });
          }}
          mode={selectedRowId === null ? 'CREATE' : 'EDIT'}
          handleSave={handleSave}
        />
      </Modal>
    </Box>
  );
};

export default HashtagsDash;
